const formatCount = (value) => String(value).padStart(2, "0");

class Countdown extends HTMLElement {
	constructor() {
		super();
		this.userDate = this.getAttribute("data-date");
		this.userTime = this.getAttribute("data-time");
		this.interval;
		this.setInterval(this.userDate, this.userTime);
		this.initSection();
	}

	onInit(userDate, userTime) {
		this.completedCountdown = this.getAttribute("data-completed");
		this.countdown = this.querySelector(".countdown__main");
		this.countdownHeading = this.querySelector(".countdown__end-info");
		this.daysEl = this.querySelector(".countdown_block_days");
		this.hoursEl = this.querySelector(".countdown_block_hours");
		this.minutesEl = this.querySelector(".countdown_block_minutes");
		this.secondsEl = this.querySelector(".countdown_block_seconds");
		this.section = this.closest(".countdown-section");
		// ----------------------------------------------------------------
		// const countdownDate = new Date(`${userDate}T${userTime}`); // 全球看到的倒计时不相同
		// 没有考虑时区 -- Fri Oct 03 2025 00:00:00 GMT+0800 (中国标准时间)
		// 没有考虑时区 -- Fri Oct 03 2025 00:00:00 GMT+0100 (英国夏令时间)
		// 没有考虑时区 -- Fri Oct 03 2025 00:00:00 GMT-0700 (北美太平洋夏令时间)

		const timezoneOffset = this.getAttribute("data-timezone-offset") || "0000";
		// 构造带有时区信息的日期字符串
		const dateString = timezoneOffset === "0000"
			? `${userDate}T${userTime}`
			: `${userDate}T${userTime}${timezoneOffset.includes("+") || timezoneOffset.includes("-") ? '' : '+'}${timezoneOffset}`;
		const countdownDate = new Date(dateString);// 全球看到的倒计时相同
		// 考虑时区 -- Fri Oct 03 2025 15:00:00 GMT+0800 (中国标准时间)
		// 考虑时区 -- Fri Oct 03 2025 08:00:00 GMT+0100 (英国夏令时间)
		// 考虑时区 -- Fri Oct 03 2025 00:00:00 GMT-0700 (北美太平洋夏令时间)

		const now = new Date();
		const distance = countdownDate.getTime() - now.getTime();
		const days = Math.floor(distance / (1000 * 60 * 60 * 24));
		const hours = Math.floor(
			(distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
		);
		const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
		const seconds = Math.floor((distance % (1000 * 60)) / 1000);
		// ----------------------------------------------------------------
		if (distance < 0 && this.completedCountdown === "hide_section") {
			clearInterval(this.interval);
			this.section.style.display = "none";
		} else if (distance < 0 && this.completedCountdown === "show_text") {
			this.countdown.style.display = "none";
			this.countdownHeading.style.display = "flex";
		} else if (distance < 0 && this.completedCountdown === "show_hyphens") {
			this.daysEl.textContent = "--";
			this.hoursEl.textContent = "--";
			this.minutesEl.textContent = "--";
			this.secondsEl.textContent = "--";
		} else {
			this.daysEl.textContent = formatCount(days);
			this.hoursEl.textContent = formatCount(hours);
			this.minutesEl.textContent = formatCount(minutes);
			this.secondsEl.textContent = formatCount(seconds);
		}
	}

	setInterval(userDate, userTime) {
		clearInterval(this.interval);
		this.interval = setInterval(
			this.onInit.bind(this, userDate, userTime),
			1000,
		);
	}

	playVideo(section) {
		const video = section.querySelector("video");

		if (video) {
			video.play();
		}
	}

	stopVideo(section) {
		const video = section.querySelector("video");

		if (video) {
			video.pause();
		}
	}

	initSection() {
		const sections = document.querySelectorAll(".countdown-section");

		const sectionObserver = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) this.playVideo(entry.target);
				else this.stopVideo(entry.target);
			});
		});

		const sectionResizeObserver = new ResizeObserver((entries) => {
			const [entry] = entries;
			this.playVideo(entry.target);
		});

		sections.forEach((section) => {
			sectionObserver.observe(section);
			sectionResizeObserver.observe(section);
		});
	}
}

customElements.define("countdown-timer", Countdown);
